exports.priceParser = function (price, decimals = 2) {
    return (Math.round(price * Math.pow(10, decimals)) / Math.pow(10, decimals))
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};
